<template>
    <div class="row">

        <div class="col-md-5">
            <label class="control-label">BUSCA POR NOME DO CLIENTE</label>
            <input type="text" v-model="nome" class="form-control" >
        </div>

        <div class="col-md-2">
            <label class="control-label">NET</label>
            <input type="text" v-model="username" class="form-control" >
        </div>

        <div class="col-md-5">
            <br/>
            <blockquote class="blockquote-reverse">
                Total de Contratos: <b>{{getContratos.length}}</b>
            </blockquote>
        </div>

        <div class="col-md-12" style="margin-top: 20px">

            <table id="mytable" class="table table-bordred table-striped">

                <thead>
                    <tr>
                        <th>CLIENTE</th>
                        <th style="text-align: center;width: 160px">NET</th>
                        <th style="text-align: center;width: 140px">AÇÕES</th>
                    </tr>
                </thead>

                <tbody v-if="getContratos.length">

                    <tr v-for="r in getContratos" v-bind:key="r._id">
                        <td>{{r.cliente.nome}}</td>
                        <td class="text-center">{{r.username}}</td>
                        <td style="text-align: center">
                            <a :href="'#/contrato/add/' + r._id" class="btn btn-primary btn-xs">
                                ABRIR <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                            </a> &nbsp;
                            <button @click="excluir(r._id)" v-if="user.level < 3" class="btn btn-danger btn-xs">
                                <i class="fa fa-trash" aria-hidden="true"></i>
                            </button>
                        </td>
                    </tr>

                </tbody>

            </table>


        </div>
    </div>
</template>
<script>
import { Contratos } from "../../../class/index";
export default {
    props: {
        cliente_id: null
    },
    data() {
        return {
            contratos: [],
            user: null,
            username: null,
            nome: null
        };
    },
    computed: {
        getContratos: function() {
            if (!this.nome && !this.username) {
                return this.contratos;
            }

            return this.contratos.filter(player => {
                if (this.username && this.nome) {
                    return (
                        player.cliente.nome
                            .toLowerCase()
                            .includes(this.nome.toLowerCase()) &&
                        player.username
                            .toLowerCase()
                            .includes(this.username.toLowerCase())
                    );
                } else if (this.username) {
                    return player.username
                        .toLowerCase()
                        .includes(this.username.toLowerCase());
                } else if (this.nome) {
                    return player.cliente.nome
                        .toLowerCase()
                        .includes(this.nome.toLowerCase());
                }
            });
        }
    },
    beforeMount() {
        this.user = this.$store.state.user;
        if (this.cliente_id) {
            this.loadByCliente();
        } else {
            this.loadByContrato();
        }
    },
    methods: {
        excluir(id) {
            // eslint-disable-next-line no-undef
            swal.queue([
                {
                    title: "Contratos",
                    confirmButtonText: "Excluir Contrato",
                    text: "Posso excluir o contrato?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return new Promise(resolve => {
                            Contratos.excluir(id)
                                .then(() => {
                                    this.load();
                                    resolve();
                                })
                                .catch(err => {
                                    console.log(err);
                                    resolve();
                                });
                        });
                    }
                }
            ]);
        },
        async loadByContrato() {
            this.contratos = await Contratos.all();
        },
        async loadByCliente() {
            this.contratos = await Contratos.allByCliente(this.cliente_id);
        }
    }
};
</script>
